import { Injectable } from '@angular/core';
import { HttpClient, HttpHandler, HttpHeaders } from '@angular/common/http';
import { UserRoles } from 'src/models/user-roles';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ProbationerDetails } from 'src/models/probationer-details';
// Removed invalid import of 'time' from 'console'
export type UserType = {
  id: number;
  fullName: string
  name: string;
  password: string;
  role: UserRoles; 
  title: string;
  organization: string;
  sessionId?: string;
  featureMode?: string;
};


export class User {
  private _user: UserType
  constructor (user: UserType){
    this._user = user
  }
  public get name(): string {
    return this._user.name
  }
  public get fullName(): string {
    console.log("fullName(): " + this._user.fullName)
    return this._user.fullName
  }
  public get featureMode(): string {
    if (this._user.featureMode == null) {
      return "probation"
    }else {
      return this._user.featureMode;
    }
  }

  public get role(): UserRoles {
    return this._user.role
  }

  public get password(): string {
    return this._user.password
  }

  public get id(): number {
    return this._user.id
  }

  public get title(): string {
    return this._user.title
  }

  public getJobTitle(): string {
    return this._user.title
  }


  public get organization(): string {
    return this._user.organization;
  }
  public get sessionId(): string {
    if (this._user.sessionId == null) {
      return ""
    }else {
      return this._user.sessionId;
    }
  }

}

const guestUserType: UserType = { id: 0, name: 'nouser', password: '', role: UserRoles.GUEST, fullName: "Guest" , title: "Guest", organization: ""}
export const guestUser = new User(guestUserType)

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private _loggedInUser: User
  //private _apiUrlBase = "https://demo.labguardhq.com:8080/api/";  // Go backend URL
  private _apiUrlBase = "http://localhost:8080/api/";  // Go backend URL
  constructor(private _http: HttpClient) { 
    let userStr = localStorage.getItem("loggedInUser")
    if (userStr != null) { 
      try {
        let user = JSON.parse(userStr)
        this._loggedInUser = user._user
      } catch (error) {
        this._loggedInUser = guestUser;
      }
    } else {
      this._loggedInUser = guestUser;
    }
    
  }

  public logOutUser(): Observable<string> {
    console.log("Logging out user " + this._loggedInUser.fullName)
    const headers = new HttpHeaders({ 'X-Session-Token': this._loggedInUser.sessionId });
    return this._http.post<string>(this.apiUrlBase + "logout", "", { headers })
      .pipe(
      // Suppress errors and return an empty string or any default value
      // You can use catchError from rxjs/operators
      catchError(() => {
        return new Observable<string>(observer => {
        observer.next('Log out failed');
        observer.complete();
        });
      })
      );

  }

  get orgUserStaffTypeString(): string {
    console.log("get orgUserStaffTypeString() " + this._loggedInUser.featureMode)
    if (this._loggedInUser.featureMode == "transport") {
      return "Admin Staff"
    } else {
      return "Admin Staff "
    }
  }

  get orgUserTypeString(): string {
    if (this._loggedInUser.featureMode == "transport") {
      return "Donors"
    } else {
      return "Donors"
    }
  }


  public get loggedInUser() : User {
    this._loggedInUser = guestUser;
    let userStr = localStorage.getItem("loggedInUser")
    //console.log("User from local storage " + userStr)
    if (userStr != null) { 
      try {
        let user = JSON.parse(userStr)
        this._loggedInUser = user._user
      } catch (error) {
        console.error("Unable to Parse stored user from local storage")
        this._loggedInUser = guestUser;
      }
    }
    return this._loggedInUser
  }
  public set loggedInUser(user: User) {
    this._loggedInUser = user
    localStorage.setItem("loggedInUser", JSON.stringify(user))
  }
  public get apiUrlBase(): string {
    return this._apiUrlBase
  }
  get http(): HttpClient {
    return this._http
  }
  authenticateUser(user: string, password: string): Observable<UserType>{
    let loggedInUser = guestUser;
    const payload = { username: user, password: password };
    return this._http.post<UserType>(this.apiUrlBase + "login", payload) 
  }

  forgotPassword(email: string): Observable<([boolean, string])> {
    const payload = { email: email , time: new Date().toISOString() };
    console.log("Forgot password payload: " + JSON.stringify(payload))
    return new Observable<([boolean, string])>((observer) => {
      this._http.post<([boolean, string])>(this.apiUrlBase + "resetpassword", payload)
      .subscribe({
        next: (response) => {
          console.log("Forgot password response: " + JSON.stringify(response))
          observer.next([(response as any).status, (response as any).message]);
          observer.complete();
        },
        error: (error) => {
          //console.error("Error in forgot password: " + error);
          observer.error([false, error.message]);
        }
      }
      );
    });
  }
  changePassword(email: string, password: string, token: string): Observable<([boolean, string])> {
    const payload = { newPassword: password, resetToken: token };
    return new Observable<([boolean, string])>((observer) => {
      this._http.post<([boolean, string])>(this.apiUrlBase + "changepassword", payload)
      .subscribe({
        next: (response) => {
          observer.next([(response as any).status, (response as any).message]);
          observer.complete();
        },
        error: (error) => {
          //console.error("Error in change password: " + error);
          observer.error([false, error.message]);
        }
      });
    });
  }

  getProbationerDetails(id: string): Observable<ProbationerDetails> {
    const headers = new HttpHeaders({ 'X-Session-Token': this.loggedInUser.sessionId });
    return this._http.get<ProbationerDetails>(this.apiUrlBase + "probationer-details/" + id, { headers });
  }
  
}
